import axios from 'axios';

// Axios própria do Painel de Clientes — login desacoplado do ERP
// (painel_usuarios, não usuarios). Token guardado numa chave própria do
// localStorage, sem nenhuma relação com a sessão do ERP (utils/sessao.js).
const painelApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
});

// Instâncias só-financeiras que fazem a gestão dos sites: na VPS principal,
// rbdigital/jcr (emaisgestor.com.br); na 2ª VPS/"É Mais Sistema", o domínio
// NU emaissistema.com.br (o subdomínio rbdigital.emaissistema.com.br nunca
// resolveu — fica na lista caso passe a resolver).
const HOSTS_PAINEL = ['rbdigital.emaisgestor.com.br', 'jcr.emaisgestor.com.br', 'rbdigital.emaissistema.com.br', 'emaissistema.com.br'];

export function hostTemPainel() {
  return typeof window !== 'undefined' && HOSTS_PAINEL.includes(window.location.hostname);
}

export function getPainelToken() {
  return localStorage.getItem('painel_token');
}

export function getPainelUsuario() {
  try { return JSON.parse(localStorage.getItem('painel_usuario') || 'null'); }
  catch { return null; }
}

export function salvarSessaoPainel(token, usuario) {
  localStorage.setItem('painel_token', token);
  localStorage.setItem('painel_usuario', JSON.stringify(usuario));
}

export function limparSessaoPainel() {
  localStorage.removeItem('painel_token');
  localStorage.removeItem('painel_usuario');
}

painelApi.interceptors.request.use((cfg) => {
  const token = getPainelToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// 401 aqui só derruba a sessão DO PAINEL (nunca navega pra /login do ERP —
// são áreas completamente separadas).
painelApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) limparSessaoPainel();
    return Promise.reject(err);
  }
);

export default painelApi;
